import { render, staticRenderFns } from "./admin-red-chirp-staff-roles.vue?vue&type=template&id=921fc104&scoped=true&"
import script from "./admin-red-chirp-staff-roles.vue?vue&type=script&lang=js&"
export * from "./admin-red-chirp-staff-roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921fc104",
  null
  
)

export default component.exports